export { default as CmsQuote } from './CmsQuote';
